import { IconButton } from "@mui/material";
import { MessageSquare } from "lucide-react";
import "./index.scss";

export default function ChatBotLauncher({ onOpen }) {
  return (
    <div className="chat-launcher-wrap">
      <IconButton className="chat-fab" onClick={onOpen}>
        <MessageSquare />
      </IconButton>
    </div>
  );
}
